// import davidHeadshot from "#src/assets/images/bios/david-lewis-headshot.jpg?raw";
// // import hankHeadshot from '@/assets/images/bios/hank-odonnell-headshot.jpg';
// import joeHeadshot from "#src/assets/images/bios/joe-paulsen-headshot.jpg?raw";
const images = import.meta.glob(
  "@/assets/images/bios/*.{png,jpg,jpeg,PNG,JPEG}",
  { eager: true, query: "?url", import: "default" },
);

function getImage(filename: string): string {
  return Object.entries(images).find(([key]) =>
    key.includes(filename),
  )?.[1] as string;
}

export const instructors = [
  {
    name: "Hank O'Donnell",
    bio: "Hank, creator of the workshop, has been an Expert EOS® Implementer since 2012 and has completed over 1,200 session days with 110 entrepreneurial leadership teams. Before joining EOS® Hank was a nationally recognized Vistage CEO Peer group chair with 3 groups composed of 62 C-Level executives as well as president of his family’s office and computer supply firm in Philadelphia. Hank has been trained by three professional coach training organizations: Co-Active Coaching; Organizational, Relationship & System Coaching and Team Coaching International. He has trained over 225 EOS® Implementers since initiating the program in 2020.",
    since: 2012,
    numSessions: 1200,
    trainedIn: [
      "Co-Active Coaching",
      "Organizational, Relationship & System Coaching",
      "Team Coaching International™",
    ],
    image: getImage("hank-odonnell-headshot.jpg"),
    expertise: [
      "EOS® Implementer since 2012",
      "Completed over 1,200 session days with 110 entrepreneurial leadership teams",
      "Previously a nationally recognized Vistage CEO Peer group chair with 3 groups of 62 C-Level executives",
      "President of his family’s office and computer supply firm in Philadelphia",
      "Trained by three professional coach training organizations: Co-Active Coaching, Organizational, Relationship & System Coaching and Team Coaching International",
      "Trained over 225 EOS® Implementers since initiating the program in 2020",
    ],
  },
  {
    name: "David Lewis",
    bio: "David became an EOS Implementer in 2020 and has completed just over 350 sessions. Before joining EOS he had a business coaching leaders and their teams. Hank was his bootcamp coach and they quickly discovered their common background and love for coaching teams. David is trained in both Co-Active Coaching (1:1), and Organizational, Relationship, & System Coaching. He has been helping lead the EOS Team Coaching program since 2021. He has led Team Coaching breakouts at QCE and the EOS Conference.",
    since: 2020,
    numSessions: 350,
    trainedIn: [
      "Co-Active Coaching (1:1)",
      "Organizational, Relationship & System Coaching",
    ],
    image: getImage("david-lewis-headshot.jpg"),
    expertise: [
      "EOS Implementer since 2020",
      "Completed over 350 sessions",
      "Business coaching leaders and their teams before joining EOS",
      "Bootcamp coach for Hank O'Donnell",
      "Trained in Co-Active Coaching (1:1) and Organizational, Relationship & System Coaching",
      "Helped lead the EOS Team Coaching program since 2021",
      "Led Team Coaching breakouts at QCE and the EOS Conference",
    ],
  },
  {
    name: "Joe Paulsen",
    bio: "Joe became an EOS Implementer in 2016 and earned Expert status in 2021. Shortly after achieving Expert status, Joe attended his first Team Coaching workshop where he realized that he had so much more to learn about Team Coaching. Having been mentored by Hank O’Donnell, Joe completed all three levels of the Team Coaching International™, certification program in 2023. In 2025, Joe will have completed his 1000 EOS session, and he continues to expand his team coaching skills with every client session and workshop that he has the privilege of leading.",
    since: 2016,
    numSessions: 1000,
    trainedIn: ["Team Coaching International™"],
    image: getImage("joe-paulson-headshot.jpg"),
    expertise: [
      "EOS Implementer since 2016, Expert status in 2021",
      "Attended first Team Coaching workshop after achieving Expert status",
      "Mentored by Hank O'Donnell",
      "Completed Team Coaching International™ certification program in 2023",
      "Will have completed 1,000 EOS session by 2025",
      "Expanding team coaching skills through every client session and workshop",
    ],
  },
];
